import axios from '~/axios'

export default {
    submit({ name, email, answers, utm }) {
        return axios.post('unauthenticated/referral-leakage-audit', {
            name,
            email,
            answers,
            utm,
        })
    },
}
